/**
 * Shared API constants for frontend
 */

/**
 * Timeout for mutation operations in milliseconds (30 seconds)
 */
export const MUTATION_TIMEOUT_MS = 30000;
